import { Images } from "@/constants/images"
import Image from "next/image"

interface LocaleLabelProps {
  locale: string
}

export const LocaleLabel = ({ locale }: LocaleLabelProps) => {
  const renderLocaleLabel = () => {
    switch (locale) {
      case "vi":
        return (
          <div className="flex items-center gap-2">
            <Image src={Images.logoVi} alt="Vietnamese" className="w-5 h-5" />
            VI
          </div>
        )
      case "en":
        return (
          <div className="flex items-center gap-2">
            <Image src={Images.logoEn} alt="English" className="w-5 h-5" />
            EN
          </div>
        )
      case "cs":
        return (
          <div className="flex items-center gap-2">
            <Image src={Images.logoCs} alt="Czech" className="w-5 h-3" />
            CS
          </div>
        )
      default:
        return (
          <div className="flex items-center gap-2">
            <Image src={Images.logoEn} alt="Default" className="w-5 h-5" />
            EN
          </div>
        )
    }
  }

  return <>{renderLocaleLabel()}</>
}
